import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { PainelFinanceiroInfo } from './models/painel-financeiro-info';
import { PainelFinanceiroApiService } from './services/painel-financeiro-api.service';


@Injectable()
export class PainelFinanceiroResolver implements Resolve<PainelFinanceiroInfo> {

  constructor(
    private painelFinanceiroApiService: PainelFinanceiroApiService,
  ) { }

  resolve(router: ActivatedRouteSnapshot): Observable<PainelFinanceiroInfo> {
    const painelFinanceiroInfo: Observable<PainelFinanceiroInfo> = this.painelFinanceiroApiService.getPainelFinanceiroInfo();

    return zip(painelFinanceiroInfo).pipe(
      map((values) => {
        return values[0];
      })
    );
  }
}